import { CxEvent } from "@spartacus/core";
import { EcommercePromotion } from "./custom-cms.model";

export class CustomPromotionEvent extends CxEvent {
  static readonly type = 'CustomPromotionEvent';
  event: string;
  ecommerce: EcommercePromotion;
}
